import { PageOptions } from '@graphcommerce/framer-next-pages'
import { ProductListDocument, ProductListQuery } from '@graphcommerce/magento-product'
import { StoreConfigDocument } from '@graphcommerce/magento-store'
import { GetStaticProps, IconSvg, LayoutHeader, MetaRobots, PageMeta } from '@graphcommerce/next-ui'
import iconLocation from '@graphcommerce/next-ui/icons/location.svg'
import { Box, Grid, Typography } from '@mui/material'
import { LayoutNavigation, LayoutNavigationProps, RowProduct, RowRenderer } from '../../components'
import { LayoutDocument } from '../../components/Layout/Layout.gql'
import getRevalidateTime from '../../constants'
import { DefaultPageDocument, DefaultPageQuery } from '../../graphql/DefaultPage.gql'
import { graphqlSharedClient, graphqlSsrClient } from '../../lib/graphql/graphqlSsrClient'

const MailToLink = ({ email }) => (
  <a
    style={{
      textDecoration: 'underline',
      color: 'black',
    }}
    href={`mailto:${email}`}
  >
    {email}
  </a>
)

const PhoneLink = ({ number }) => (
  <a
    style={{
      textDecoration: 'underline',
      color: 'black',
    }}
    href={`tel:${number}`}
  >
    {number}
  </a>
)

type Props = DefaultPageQuery & {
  latestList: ProductListQuery
  favoritesList: ProductListQuery
  swipableList: ProductListQuery
}
type RouteProps = { url: string }
type GetPageStaticProps = GetStaticProps<LayoutNavigationProps, Props, RouteProps>

function ContactUs(props: Props) {
  return (
    <Box
      sx={{
        paddingTop: 1,
        paddingBottom: 10,
      }}
    >
      <Typography variant='h3' align='center'>
        Ti aspettiamo in show-room
      </Typography>
      <Grid
        container
        spacing={2}
        style={{
          flexGrow: 1,
        }}
      >
        <Grid
          item
          xs={6}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <IconSvg
            src={iconLocation}
            size='large'
            style={{
              fontSize: 48,
              marginBottom: 3,
            }}
          />
          <div>
            <Typography variant='h3' align='center'>
              Sede di Firenze
            </Typography>
            <Typography variant='body1' align='center'>
              <a
                style={{
                  textDecoration: 'underline',
                  color: 'black',
                }}
                href='https://www.google.com/maps/search/?api=1&query=Jumboffice+Via+Vittorio+Emanuele+19%2C+50041+Calenzano+FI'
                target='_blank'
                rel='nofollow noopener noreferrer'
                onClick={(e) => {
                  if (
                    navigator.platform.indexOf('iPhone') !== -1 ||
                    navigator.platform.indexOf('iPad') !== -1 ||
                    navigator.platform.indexOf('iPod') !== -1
                  ) {
                    e.preventDefault()
                    window.open(
                      'maps://maps.google.com/maps?daddr=Jumboffice+Via+Vittorio+Emanuele+19%2C+50041+Calenzano+FI&amp;ll=',
                    )
                  }
                }}
              >
                Vittorio Emanuele, 19 (uscita autostrada A1) Calenzano, Firenze
              </a>
            </Typography>
            <Typography variant='body1' align='center'>
              <MailToLink email='info@jode.it' />
            </Typography>
            <Typography variant='body1' align='center'>
              <PhoneLink number='05588324' />
            </Typography>
            <Typography variant='h4' align='center'>
              Orario di apertura showroom
            </Typography>
            <Typography variant='body1' align='center'>
              dal Lunedi al Venerdi 9-13 / 14:30-19 Sabato chiuso
            </Typography>
          </div>

          {/* MAPPA */}
          <iframe
            title='JoDesign - Firenze'
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.315455238111!2d11.172446200000001!3d43.849289899999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132a57fcdfab9dcd%3A0xc3f765f7b9f74269!2sJumbOffice!5e0!3m2!1sit!2sit!4v1716906240090!5m2!1sit!2sit'
            width='600'
            height='450'
            style={{ border: 0, marginTop: '2rem' }}
            loading='lazy'
          />
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <IconSvg
            src={iconLocation}
            size='large'
            style={{
              fontSize: 48,
              marginBottom: 3,
            }}
          />
          <div>
            <Typography variant='h3' align='center'>
              Sede di Roma
            </Typography>
            <Typography variant='body1' align='center'>
              <a
                style={{
                  textDecoration: 'underline',
                  color: 'black',
                }}
                href='https://www.google.com/maps/search/?api=1&query=Jumboffice+Via+Tiburtina%2C+1010%2C+00156+Roma+RM'
                target='_blank'
                rel='nofollow noopener noreferrer'
                onClick={(e) => {
                  if (
                    navigator.platform.indexOf('iPhone') !== -1 ||
                    navigator.platform.indexOf('iPad') !== -1 ||
                    navigator.platform.indexOf('iPod') !== -1
                  ) {
                    e.preventDefault()
                    window.open(
                      'maps://maps.google.com/maps?daddr=Jumboffice+Via+Tiburtina%2C+1010%2C+00156+Roma+RM&amp;ll=',
                    )
                  }
                }}
              >
                Via Tiburtina, 1010 00156 ROMA
              </a>
            </Typography>
            <Typography variant='body1' align='center'>
              <MailToLink email='info@jode.it' />
            </Typography>
            <Typography variant='body1' align='center'>
              <PhoneLink number='0641228004' />
            </Typography>
            <Typography variant='h4' align='center'>
              Orario di apertura showroom
            </Typography>
            <Typography variant='body1' align='center'>
              dal Lunedi al Venerdi 9.00 - 18.00 Sabato chiuso
            </Typography>
          </div>

          <iframe
            title='JoDesign - Roma'
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.2288113815594!2d12.5788794!3d41.9309344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f6379284a353d%3A0x2963cab46e5d0b5d!2sJumboffice!5e0!3m2!1sit!2sit!4v1716906525484!5m2!1sit!2sit'
            width='600'
            height='450'
            style={{ border: 0, marginTop: '2rem' }}
            loading='lazy'
          />
        </Grid>
      </Grid>
    </Box>
  )
}

ContactUs.pageOptions = {
  Layout: LayoutNavigation,
} as PageOptions

export default ContactUs

export const getStaticProps: GetPageStaticProps = async ({ locale }) => {
  const client = graphqlSharedClient(locale)
  const staticClient = graphqlSsrClient(locale)

  const conf = client.query({ query: StoreConfigDocument })
  const page = staticClient.query({ query: DefaultPageDocument, variables: { url: `page/home` } })
  const layout = staticClient.query({ query: LayoutDocument })
  const revalidate = getRevalidateTime()

  // todo(paales): Remove when https://github.com/Urigo/graphql-mesh/issues/1257 is resolved
  const favoritesList = staticClient.query({
    query: ProductListDocument,
    variables: { pageSize: 8, filters: { category_uid: { eq: 'Mg==' } } },
  })

  const latestList = staticClient.query({
    query: ProductListDocument,
    variables: { pageSize: 8, filters: { category_uid: { eq: 'Mg==' } } },
  })

  const swipableList = staticClient.query({
    query: ProductListDocument,
    variables: { pageSize: 8, filters: { category_uid: { eq: 'Mg==' } } },
  })

  if (!(await page).data.pages?.[0]) return { notFound: true }

  return {
    props: {
      ...(await page).data,
      ...(await layout).data,
      latestList: (await latestList).data,
      favoritesList: (await favoritesList).data,
      swipableList: (await swipableList).data,
      apolloState: await conf.then(() => client.cache.extract()),
    },
    revalidate,
  }
}
